var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { BodyText } from '../BodyText';
export const StatusLight = (_a) => {
    var { children, className, full, reverse, split, disabled, pulsing, onClick, onMouseOver, href, color = 'default' } = _a, props = __rest(_a, ["children", "className", "full", "reverse", "split", "disabled", "pulsing", "onClick", "onMouseOver", "href", "color"]);
    const isCustomColor = () => {
        const uniqueColors = [
            'default',
            'info',
            'success',
            'warning',
            'critical',
        ];
        if (!uniqueColors.includes(color))
            return true;
        return false;
    };
    const colorClasses = () => {
        if (!disabled && !isCustomColor()) {
            return `StatusLight__indicator--${color}`;
        }
        return false;
    };
    const StatusLightIndicatorClasses = classnames('StatusLight__indicator', colorClasses(), {
        'StatusLight__indicator--disabled': disabled,
    });
    const StatusLightClasses = classnames('StatusLight', className, {
        'StatusLight--disabled': disabled,
        'StatusLight--reverse': reverse,
        'StatusLight--full': full,
        'StatusLight--split': split,
        'StatusLight--pulsing': pulsing,
        'StatusLight--action': onClick || onMouseOver || href,
    });
    const StatusLightElement = href ? 'a' : 'div';
    return (React.createElement(StatusLightElement, Object.assign({ className: StatusLightClasses, href: href, "data-anvil-component": "StatusLight" }, props),
        React.createElement("span", { className: StatusLightIndicatorClasses, style: isCustomColor() ? { backgroundColor: color } : null }),
        children !== undefined && children !== null && (React.createElement(BodyText, { size: "small", className: "StatusLight__label" }, children))));
};
//# sourceMappingURL=StatusLight.js.map